import {
  MORE_COLOURS,
  MIX_MATCH
} from "../../../../../../state/modules/search/constants";

export const getBadgeText = ({ type, formatTranslation }) => {
  if (type === MORE_COLOURS) {
    return formatTranslation("plp_web_product_tile_badge_more_colors");
  } else if (type === MIX_MATCH) {
    return formatTranslation("plp_web_product_tile_badge_mix_match");
  }

  return null;
};
